import * as basic from '../../../config/basic'

export const home = {
  introduction: {
    title: '大赛介绍',
    subTitle: 'FinTechathon',
    intro: [
      '2023 深圳国际金融科技大赛——西丽湖金融科技大学生挑战赛，是一场面向金融科技前沿技术领域的学生团队竞赛活动，是深圳市金融科技节的重要一环。大赛前身是“ FinTechathon 微众银行金融科技高校技术大赛”，去年完成赛事品牌升级，致力于推动国内外高校学生探索金融科技领域的技术应用创新，促进政、学、企三方交流，全面提高学生的创新能力、实践能力和就业竞争力。过往四届共吸引 3500 余名来自海内外知名高校的学生参赛，成功在行业内掀起科技创新浪潮。',
      '本届大赛倾力打造人工智能、区块链、金融产品经理三大赛道，多维挖掘高校学生的优秀金融科技创新成果。三个赛道将分别角逐出 10 支队伍进行最终的巅峰对决，深圳市地方金融监督管理局、深圳市福田区人民政府、深圳市南山区人民政府、深圳大学、微众银行、深圳香蜜湖国际金融科技研究院等多方将再次合力，共同打造一场精彩纷呈的金融科技赛事，将为获奖队伍提供超过 69 万元人民币的赛事奖金，以激励高校人才持续积极投入到金融科技创新事业中！',
    ],
    poster: 'https://static001.geekbang.org/resource/image/e0/ce/e0b61ed77b04a2dab887259caea498ce.jpeg',
    video: 'https://static001.geekbang.org/static/biz/file/webank/webank20231015.mp4'
  },

  wxShare: {
    title: '深圳国际金融科技大赛——西丽湖金融科技大学生挑战赛',
    introduce: '是一场面向金融科技前沿技术领域的学生团队竞赛活动。大赛前身是 FinTechathon 微众银行金融科技高校技术大赛，致力于推动国内外高校学生探索金融科技领域的技术应用创新，促进政、学、企三方交流，全面提高学生的创新能力、实践能力和就业竞争力。过往三届共吸引2100余名来自海内外知名高校的学生参赛，成功在行业内掀起科技创新浪潮。',
    img: 'https://static001.geekbang.org/resource/image/42/d9/42ee921bd490be84367e6c105e1bfed9.jpg'
  },

  bars: [
    {
      name: '大赛介绍',
      id: '#introduction'
    },
    {
      name: '赛题说明',
      id: '#note'
    },
    {
      name: '大赛日程',
      id: '#schedule'
    },
    {
      name: '奖项设置',
      id: '#prize'
    },
    {
      name: '特邀顾问',
      id: '#judge'
    },
    {
      name: '大赛评委',
      id: '#judgeSaidao'
    },
    {
      name: '合作伙伴',
      id: '#partners'
    }
  ],

  barQrcodeList: [
    {
      id: 'AI',
      img: basic.aiLogoGrey,
      hoverImg: basic.aiLogoBlack,
      qrcode: 'https://static001.geekbang.org/resource/image/23/7d/2302f369580700865ae7682f814a267d.png',
      name: '人工智能小助手'
    },
    {
      id: 'blockchain',
      img: basic.blockchainLogoGrey,
      hoverImg: basic.blockchainLogoBlack,
      qrcode: 'https://static001.geekbang.org/resource/image/c5/e8/c5c5eb2d5ba06bdccbc89c99a687b8e8.png',
      name: '区块链小助手'
    },
    {
      id: 'pm',
      img: basic.pmLogoGrey,
      hoverImg: basic.pmLogoBlack,
      qrcode: 'https://static001.geekbang.org/resource/image/19/13/195e8a45f84e8fe2bd34faa29a931e13.png',
      name: '产品经理小助手'
    }
  ],

  nav: [
    {
      title: '赛题设置',
      name: 'Home',
      // hash: '#note',
      id: 1
    },
    {
      title: '参赛规则',
      name: 'Rule',
      id: 2
    },
    {
      title: '往届回顾',
      name: '',
      id: 3,
      children: [
        {
          title: '2022 第四届',
          name: 'Past2022',
          id: 3.0
        },
        {
          title: '2021 第三届',
          name: 'Past2021',
          id: 3.1
        },
        {
          title: '2020 第二届',
          name: 'Past2020',
          id: 3.2
        },
        {
          title: '2019 第一届',
          name: 'Past2019',
          id: 3.3
        }
      ]
    },
    {
      title: '学习园地',
      name: '',
      id: 4,
      children: [
        {
          title: '人工智能',
          name: 'SupportAI',
          id: 4.2
        },
        {
          title: '区块链',
          name: 'SupportBlockchain',
          id: 4.1
        },
        {
          title: '产品经理',
          name: 'SupportPM',
          id: 4.3
        }
      ]
    },
    {
      title: '主办方介绍',
      name: 'Home',
      // hash: '#partners',
      id: 5,
      children: [
        {
          title: '深大微众金融科技学院',
          name: 'https://swift.szu.edu.cn/info/1002/1621.htm',
          id: 5.1
        },
        {
          title: '微众银行',
          name: 'https://www.webank.com/#/home',
          id: 5.2
        }
      ]
    }
  ],

  note: [
    {
      type: 'ai',
      logo: basic.aiLogoBg,
      title: '人工智能赛道',
      introTitle: '开放式命题',
      link: {
        type: 'out',
        word: '学习园地',
        title: '敬请期待',
        isValid: true,
        link: process.env.VUE_APP_BUILD_ENV !== 'test' ? 'https://www.infoq.cn/zones/fintechathon/campus2023/support/ai' : 'https://www.infoq.cn/zones/test/fintechathon/campus2023/support/ai'
      },
      intro: '基于 FATE 平台（<a style="color: blue" href="https://github.com/FederatedAI/FATE" target="_blank">https://github.com/FederatedAI/FATE</a>），设计纵向联邦学习、横向联邦学习或者联邦大模型创新性产品或算法。包括并不限于联合风控、联合营销、智能权益定价、数据交易定价等场景。<br>要求：<br>1.参赛项目必须使用 FATE 开源技术实现；<br>2.参赛学生必须把自己的实现代码提交到自己的 github 账号下供评委考核。',
      introbg: 'https://static001.geekbang.org/resource/image/a7/83/a7e887f917f58662a913bd237dacda83.png',
      moreBtn: {
        details: '赛题参考',
        detailsText: {
          title: '参考题目',
          warn: '（以下为人工智能赛道2019-2022年度冠军作品案例）',
          content: '',
          illustrate: [
            {
              id: '02',
              illustrateContent: '<strong>2019年</strong><br><strong>作品名称</strong>：联邦微车险—基于横向联邦学习和 5G 技术的个性化车险定价方案。<br><strong>简介</strong>：5G 和车联网将我们带入车车互联的时代，未来，每台车都可作为独立的数据中心和计算单元，实现本地建模运算；联邦学习则使得数据不出本地的多方联合建模成为可能。该作品是一款基于联邦学习和 5G 技术的新型车险定价方案。',
            },
            {
              id: '03',
              illustrateContent: '<strong>2020年</strong><br><strong>作品名称</strong>：Fusing Attack<br><strong>简介</strong>：Fusing Attack 是团队开发的以超高转移性攻击算法为核心优势的针对人脸识别系统的黑盒对抗攻击。依托多种高性能攻击模块和转移性增强模块，Fusing Attack 能够成功攻破完全未知的黑盒人脸识别系统，任意操纵目标模型的识别结果。',
            },
            {
              id: '04',
              illustrateContent: '<strong>2021年</strong><br><strong>作品名称</strong>：面向学生心理健康的预防监测系统-基于FATE平台<br><strong>简介</strong>：内卷时代来临，焦虑无处不在。心理健康关乎个人发展，结合学生个体心理健康防控的实际需求，本作品结合联邦学习保护隐私的优势，打造一个安全科学的多模态信息预测的平台，推进学生与健康的“最后一公里”，未来将联合更多机构为更广人群提供预测诊疗服务。',
            },
            {
              id: '5',
              illustrateContent: '<strong>2022年</strong><br><strong>作品名称</strong>：面向智能体音感知的联邦学习系统-基于FATE平台<br><strong>简介</strong>：体音信号因其易采集、普适和“非侵入”等特点被证明可用于临床“非侵入式”智能诊疗。然而，数据安全与隐私问题使得医疗数据呈现“数据孤岛”形式，严重制约了医疗 AI 的发展，该团队的作品便基于以上问题提出了解决方案，本作品是一个在医疗场景下基于FATE联邦学习框架构建智能体音感知系统，可部署于各医院，在保护患者隐私的同时将促进多中心联合建模。',
            }
          ],
          illustrateWarn: ''
          // illustrateWarn: '注：以上赛题仅供参考，欢迎大家积极探索更多ESG相关的使用场景。'
        },
        understandMore: '学习园地',
        understandMoreLink: process.env.VUE_APP_BUILD_ENV !== 'test' ? 'https://www.infoq.cn/zones/fintechathon/campus2023/support/ai' : 'https://www.infoq.cn/zones/test/fintechathon/campus2023/support/ai'
      }
    },
    {
      type: 'blockchain',
      logo: basic.blockchainLogoBg,
      title: '区块链赛道',
      introTitle: '开放式命题',
      link: {
        type: 'in',
        word: '学习园地',
        isValid: true,
        link: process.env.VUE_APP_BUILD_ENV !== 'test' ? 'https://www.infoq.cn/zones/fintechathon/campus2023/support/blockchain' : 'https://www.infoq.cn/zones/test/fintechathon/campus2023/support/blockchain'
      },
      intro: '参赛项目基于FISCO BCOS平台及微众区块链系列开源技术设计并开发一个区块链系统，以解决ESG相关的某个行业/场景的痛点或问题，如将区块链技术应用于大湾区一体化、双碳、乡村振兴、公共服务、绿色金融等领域。',
      introbg: 'https://static001.geekbang.org/resource/image/e9/b2/e9194197aef9b1c408d3143c08d553b2.png',
      warn: '比赛题目（包括且不限于以下三个方向，欢迎大家积极探索区块链与更多场景结合的可能性）',
      moreBtn: {
        details: '赛题参考',
        detailsText: {
          title: '参考题目',
          warn: '（以下题目仅供参考，欢迎大家积极探索更多 ESG 相关的使用场景）',
          content: '基于FISCO BCOS平台及微众区块链系列开源技术设计并开发一个区块链系统，微众区块链系列开源技术包括：WeBASE 中间件、WeDPR隐私保护、WeCross 通用跨链、WeIdentity 数字身份管理、WeEvent 消息协作、Truora可信预言机、DDCMS数据协作、WeBankBlockchain-Data数据治理等',
          illustrate: [
            {
              id: '01',
              illustrateContent: '一、双碳方向：2022年6月科技部等九部门印发的《科技支撑碳达峰碳中和实施方案（2022—2030年）》提出“加强科技创新对碳排放监测、计量、核查、核算、认证、评估、监管以及碳汇的技术体系和标准体系建设的支撑保障，为国家碳达峰碳中和工作提供决策支撑”。区块链具有数据可溯源、不可篡改的特性，在碳排放数据可信采集、可信存储和可信共享等方面有不可取代的优势。请设计一个区块链系统，可满足碳排放治理的一系列需求，包括但不限于： 支持碳排放数据可信采集、存储、核查、分析；设计碳排放权交易、碳排放账户管理体系；搭建可靠可信的碳监管环境，进行碳数据报送，碳足迹追踪；实现降本增效，助力实现“双碳“目标。',
            },
            {
              id: '02',
              illustrateContent: '二、大湾区数据要素和数据资产跨境流通方向：2022年12月，国务院印发《关于构建数据基础制度更好发挥数据要素作用的意见》（以下称《数据二十条》），《数据二十条》指出数据作为新型生产要素，是数字化、网络化、智能化的基础，提出可以通过技术手段，积极探索“原始数据不出域、数据可用不可见”的交易范式，保障数据要素和数据资产流通。区块链技术具有较强的技术融合性和制度渗透性，针对粤港澳大湾区“一国两制三法域”重要特征，在非统一制度和规则下如何实现区域融合和协调发展具有天然优势。请结合具体场景设计一个区块链系统，运用隐私保护相关技术，保证可信数据流转的同时，实现数据要素和数据资产跨境、跨域使用，促进大湾区重要数据要素高效利用，助力大湾区一体化融合发展。',
            },
            {
              id: '03',
              illustrateContent: '三、慈善公益方向：2022年12月30日，《中华人民共和国慈善法（修订草案）》（简称“草案”）公开向社会征求意见。《中华人民共和国慈善法》修订对规范慈善活动，提升慈善组织的发展水平，加强慈善行业的自律和监管，实现以法促善、依法行善， 具有重大意义。草案中提出“支持引导大数据、云计算、区块链等现代信息技术手段在慈善领域的应用”。请设计一个区块链系统，利用区块链分布式对等、防篡改、可追溯、透明可信等特性，将捐赠物资和慈善款记录上链，设计跟踪机制，实现物资和慈善款的流向可追溯，慈善机构的财务数据真实可审计，让慈善资源“用之于民”。',
            }
          ],
          illustrateWarn: ''
          // illustrateWarn: '注：以上赛题仅供参考，欢迎大家积极探索更多ESG相关的使用场景。'
        },
        understandMore: '学习园地',
        understandMoreLink: process.env.VUE_APP_BUILD_ENV !== 'test' ? 'https://www.infoq.cn/zones/fintechathon/campus2023/support/blockchain' : 'https://www.infoq.cn/zones/test/fintechathon/campus2023/support/blockchain'
      }
    },
    {
      type: 'product',
      logo: basic.pmLogoBg,
      title: '产品经理赛道',
      introTitle: '银行线上场景的交互式智能柜台服务',
      link: {
        type: 'out',
        word: '学习园地',
        title: '敬请期待',
        isValid: true,
        link: ''
      },
      intro: '基于对话式交互的应用进行银行产品方案设计，实现对客户全场景的陪伴式交互，为客户提供智能、便捷、懂用户、有温度的线上银行服务（可选择微众银行App、微众银行We2000小程序或其他银行产品作为产品框架进行设计）。',
      introbg: 'https://static001.geekbang.org/resource/image/a7/83/a7e887f917f58662a913bd237dacda83.png',
      moreBtn: {
        understandMore: '学习园地',
        understandMoreLink: process.env.VUE_APP_BUILD_ENV !== 'test' ? 'https://www.infoq.cn/zones/fintechathon/campus2023/support/pm' : 'https://www.infoq.cn/zones/test/fintechathon/campus2023/support/pm',
        details: '赛题参考',
        detailsText: {
          title: '参考题目',
          content: '基于对话式交互的应用进行银行产品方案设计，实现对客户全场景的陪伴式交互，为客户提供智能、便捷、懂用户、有温度的线上银行服务（可选择微众银行App、微众银行We2000小程序或其他银行产品作为产品框架进行设计）。',
          illustrate: [
            {
              id: '01',
              illustrateContent: '随着银行业数字化转型，人们越来越依赖于通过线上办理各类银行服务，从开户、存款理财、智能投顾、客服咨询等各类场景，因此如何能够像线下网点一样提供有温度的对话式服务，同时又能基于AIGC、大数据提供个性化的智能服务成为了一个可以探索落地的研究方向。',
            },
            {
              id: '02',
              illustrateContent: '请基于对话式交互的应用进行产品方案设计，使银行实现对客户全场景的陪伴式的交互服务，为客户提供智能、便捷、懂用户、有温度的线上银行（可基于微众银行App或微众银行We2000小程序作为产品框架进行设计）。',
            },
            {
              id: '03',
              illustrateContent: '微众银行App及微众银行We2000小程序介绍：',
            },
            {
              id: '04',
              illustrateContent: '（1）微众银行App：微众银行财富+ 基于微众银行App ，以买方视角的金融产品甄选、专业有温度的服务体验，打造专业、安全、高效的一站式数字化财富管理服务，为用户精选各类产品，提供多元化资产配置选择。',
            },
            {
              id: '05',
              illustrateContent: '（2）微众银行We2000小程序：微众银行财富+推出的集账户、闲钱管理、消费支付、积分权益等服务一体化的数字账户，为年轻用户提供便捷、专业的服务。',
            }
          ],
          imgsList: [
            {
              logo: 'https://static001.geekbang.org/resource/image/80/16/8040d55839dcfdab4291b2acfaa89d16.png',
              text: '微众银行 App'
            },
            {
              logo: 'https://static001.geekbang.org/resource/image/09/2e/095525470af5707acdccdcfcffde7c2e.png',
              text: '微众银行We2000'
            }
          ]
        },
      }
    }
  ],

  review: {
    btn: {
      link: 'https://fintech.webank.com/past-events/fintechathon-2019/',
      name: '2019 赛事回顾'
    },
    left: {
      poster: require('@/assets/img/video_img.png'),
      video: 'http://1258566428.vod2.myqcloud.com/2056e5f1vodcq1258566428/a0e904b15285890806028324769/tI6SMGAAHVgA.mp4'
    },
    right: [
      {
        img: require('@/assets/img/review/1.jpg'),
        link: '',
        h3: '2019年 FinTechathon 微众银行首届金融科技高校技术大赛'
      },
      {
        img: require('@/assets/img/review/2.jpg'),
        link: '',
        h3: '人工智能赛道评委主席杨强、区块链赛道评委主席马智涛为人工智能赛道第一名团队颁奖'
      },
      {
        img: require('@/assets/img/review/3.jpg'),
        link: '',
        h3: '人工智能赛道评委主席杨强、区块链赛道评委主席马智涛为区块链赛道第一名团队颁奖'
      },
      {
        img: require('@/assets/img/review/4.jpg'),
        link: '',
        h3: '2019年08月26日，微众银行首届金融科技高校技术大赛颁奖典礼现场'
      },
      {
        img: require('@/assets/img/review/5.jpg'),
        link: '',
        h3: '2019年08月26日，微众银行首届金融科技高校技术大赛颁奖典礼现场'
      },
      {
        img: require('@/assets/img/review/6.jpg'),
        link: '',
        h3: '2019年08月26日，Brett King 带来主题为《未来银行4.0 》的精彩分享'
      },
      {
        img: require('@/assets/img/review/7.jpg'),
        link: '',
        h3: '2019年08月24日-25日，两天一夜的黑客松比赛现场'
      },
      {
        img: require('@/assets/img/review/8.jpg'),
        link: '',
        h3: '人工智能赛道的技术支持老师在为参赛选手解疑答惑'
      },
      {
        img: require('@/assets/img/review/9.jpg'),
        link: '',
        h3: '区块链赛道的技术支持老师在为参赛选手解疑答惑'
      },
      {
        img: require('@/assets/img/review/10.jpg'),
        link: '',
        h3: '人工智能赛道的选手进行路演答辩'
      },
      {
        img: require('@/assets/img/review/11.jpg'),
        link: '',
        h3: '区块链赛道的选手进行路演答辩'
      },
      {
        img: require('@/assets/img/review/12.jpg'),
        link: '',
        h3: '2019年08月26日，微众银行首届金融科技高校技术大赛颁奖典礼现场'
      }
    ]
  },

  schedule: {
    title: {
      h1: '大赛日程',
      titleBg: require('@/assets/img/title-bg.png')
    },
    subTitle: '*在大赛过程中，如因受到不可抗力因素或其他外部因素影响，发生了赛果、决赛形式、赛制、答辩规则等内容调整的情况，大赛组委会将通过大赛官网、邮件及大赛助手进行通知。',
  },

  prize: {
    title: {
      h1: '奖项设置',
      titleBg: require('@/assets/img/title-bg.png')
    },
    desc: '本次竞赛评审结果由大赛专家委员会审定，并在大赛官方网站公布。获奖证书由大赛组委会统一印制、颁发。总决赛中，各赛道根据最终成绩排名，分别设置一等奖、二等奖、三等奖，颁发证书及奖金（税前）。',
    prizes: [
      {
        type: 'ai',
        list: [
          {
            img: 'https://static001.geekbang.org/resource/image/7e/7e/7e4b87a534ecc6yy7ffbfe4f8321d47e.png',
            price: 'https://static001.geekbang.org/resource/image/dc/ac/dc020bdea744674c7b180f679fa9ccac.png',
            rank: 'https://static001.geekbang.org/resource/image/e5/2f/e518ed97f3c315d95b74eb0c1eddbf2f.png'
          }
        ]
      },
      {
        type: 'block',
        list: [
          {
            img: 'https://static001.geekbang.org/resource/image/fc/b2/fc9bf9cf8a5a8266c73139ba6a22f6b2.png',
            price: 'https://static001.geekbang.org/resource/image/5c/b7/5cf81cc9e91d2065c0e479a8d93d14b7.png',
            rank: 'https://static001.geekbang.org/resource/image/82/31/82efc9b1e7aa42bb43b8154b379fe831.png'
          }
        ]
      },
      {
        type: 'good',
        list: [
          {
            img: 'https://static001.geekbang.org/resource/image/c8/59/c8e2633a9348bd76435318c1383f8359.png',
            price: 'https://static001.geekbang.org/resource/image/e4/11/e44d34f8cc1db989ba65c211849b8a11.png',
            rank: 'https://static001.geekbang.org/resource/image/b9/03/b94acbdb5e83e0c976738edea2655b03.png'
          }
        ]
      }
    ],
    hint: '˙*人工智能、区块链、产品经理赛道中产生一等奖、二等奖、三等奖各一人',
    competitionImg: 'https://static001.geekbang.org/resource/image/ce/9f/ce95b727cd4dddb28f8e2f0144c88a9f.png',
    competitionBright: [
      {
        img: 'https://static001.geekbang.org/resource/image/46/62/462c670ba013c2cf659ccf5dfc83c762.png',
        text: '69万奖金池'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/59/3d/593b6fa3aa2cdf8c0bc0ef46f5f1443d.png',
        text: '获奖证书和奖杯'
      }
    ],
    competitionSchool: {
      school: ['微众银行', '极客邦科技', '金链盟', ' FISCO BCOS', '赛氪', 'DC竞赛网', '深圳大学', '和鲸社区'],
      interviewIcon: 'https://static001.geekbang.org/resource/image/49/3f/49beda842d0775c4yy28efd644c2653f.png',
      interview: '实习面试直通车'
    }
  },

  judges: [
    {
      title: {
        h1: '特邀学术顾问',
        titleBg: 'https://static001.geekbang.org/resource/image/b2/68/b2549fc7a2c357acb811d10525df6e68.png',
        tip: '（按姓氏首字母排序）'
      },
      list: [
        {
          headImg: 'https://static001.geekbang.org/resource/image/04/7d/043e92fba712a4cbb74d10c240597f7d.png',
          name: '许宪春',
          title: '国家统计局原副局长'
        },
        {
          headImg: 'https://static001.geekbang.org/resource/image/fa/bd/fa5b8b032b58ae82f9775f8da62636bd.png',
          name: '杨强',
          title: '加拿大皇家科学院院士、加拿大工程院院士、微众银行首席人工智能官'
        },
        {
          headImg: 'https://static001.geekbang.org/resource/image/7a/61/7a3f87d9185822977e43fb75a8e62b61.png',
          name: '张健华',
          title: '清华大学五道口金融学院教授、华夏银行原行长、中国人民银行研究局原局长'
        },
        {
          headImg: 'https://static001.geekbang.org/resource/image/02/8a/021a4c69f24a9dd46194c2a57610758a.png',
          name: '吕仲涛',
          title: '中国工商银行首席技术官'
        },
        {
          headImg: 'https://static001.geekbang.org/resource/image/0b/c3/0bdb08c2dc721432bc34378a939603c3.png',
          name: '刘晓春',
          title: '上海新金融研究院副院长、浙商银行原行长'
        },
        {
          headImg: 'https://static001.geekbang.org/resource/image/a3/84/a37yy68f34789f6164a14afd53148584.png',
          name: '金  李',
          title: '全国政协委员、南方科技大学副校长'
        },
        {
          headImg: 'https://static001.geekbang.org/resource/image/2d/7f/2d797f816ecb75e7a15fb59515768f7f.png',
          name: '高  峰',
          title: '中国银行业协会首席信息官'
        }
      ]
    },
    // {
    //   title: {
    //     h1: '特邀行业顾问',
    //     titleBg: require('@/assets/img/title-bg.png'),
    //     tip: '（按姓氏首字母排序）'
    //   },
    //   list: [
    //     // {
    //     //   headImg: require('../../../assets/img/judges/11.png'),
    //     //   name: '黄宇铮',
    //     //   title: '博裕资本董事总经理'
    //     // },
    //     {
    //       headImg: require('../../../assets/img/judges/12.png'),
    //       name: '刘明',
    //       title: '鹏城实验室人工智能开源平台办公室主任<br/>OpenI启智新一代人工智能开源开放平台秘书处秘书长'
    //     }
    //     // {
    //     //   headImg: require('../../../assets/img/judges/13.png'),
    //     //   name: '钟惠馨',
    //     //   title: '麦肯锡全球董事、合伙人'
    //     // }
    //   ]
    // }
  ],

  judgeSaidao: [
    {
      id: 0,
      type: 'ai',
      logo: basic.aiLogo,
      logoBlack: basic.aiLogoBlack,
      logoGrey: basic.aiLogoGrey,
      fontActiveBgColor: '#FEE7E5',
      fontActiveColor: '#E1574D',
      title: '人工智能赛道',
      mobileTitle: '人工智能',
      titleBgColor: 'linear-gradient(270deg,rgba(253,187,181,0),#fedcda)',
      mobileTitleBgColor: 'linear-gradient(360deg, rgba(253,187,181,0) 0%, #FEDCDA 100%)',
      mainJudge: {
        img: 'https://static001.geekbang.org/resource/image/b7/32/b7d9097c039f2dd46a120ac8ed2fb032.png',
        mobileImg: 'https://static001.geekbang.org/resource/image/05/bc/0546d0d957de80c67c849edc3251bdbc.png',
        name: '杨强',
        conTitle: '评委主席',
        position: '加拿大皇家科学院院士、加拿大工程院院士、微众银行首席人工智能官'
      },
      Judgers: {
        title: '赛道评审',
        mobileTitle: '赛道评审',
        bgBg: 'https://static001.geekbang.org/resource/image/fc/b9/fcd1fd153a2be447379276718d45c8b9.png',
        data: [
          { name: '范力欣', position: '微众银行人工智能首席科学家' },
          { name: '杨海军', position: '微众银行人工智能部室高级经理' },
          { name: '范涛', position: '微众银行人工智能资深研究员' },
          { name: '张文宇', position: '浙江财经大学盈阳金融科技学院院长' },
          { name: '何道敬', position: '哈工大计算学部教授，哈工大（深圳）计算机学院副院长，哈工大（深圳）计算与智能研究院常务副院长' },
          { name: '潘微科', position: '深圳大学计算机与软件学院教授' }
        ]
      }
    },
    {
      id: 1,
      type: 'blockchain',
      logo: basic.blockchainLogo,
      logoBlack: basic.blockchainLogoBlack,
      logoGrey: basic.blockchainLogoGrey,
      fontActiveBgColor: '#F2EDFF',
      fontActiveColor: '#7652E1',
      title: '区块链赛道',
      mobileTitle: '区块链',
      titleBgColor: 'linear-gradient(225deg, rgba(225,208,255,0) 0%, #ECE3FF 100%)',
      mobileTitleBgColor: 'linear-gradient(360deg, rgba(225,208,255,0) 0%, #ECE3FF 100%)',
      mainJudge: {
        img: 'https://static001.geekbang.org/resource/image/57/13/576d497b3bce6f644d534a31d4c9e813.png',
        mobileImg: 'https://static001.geekbang.org/resource/image/5a/cd/5a5c3aa212e01c4da88fb2610d8577cd.png',
        name: '马智涛',
        conTitle: '评委主席',
        position: '微众银行副行长兼首席信息官',
        // borderBg: basic.borderBlueBg,
      },
      Judgers: {
        title: '赛道评审',
        mobileTitle: '赛道评审',
        bgBg: 'https://static001.geekbang.org/resource/image/98/82/988918324ec22729b11b268b754b2a82.png',
        // borderBg: basic.borderBlueBg,
        data: [
          { name: '范瑞彬', position: '微众银行分布式商业科技发展部副总经理' },
          { name: '张开翔', position: '微众银行区块链首席架构师' },
          { name: '李辉忠', position: '微众银行区块链底层平台研发负责人' },
          { name: '苏小康', position: '微众银行区块链应用研发负责人' },
          { name: '孙毅', position: '中科院计算所研究员<br />CCF 区块链专委会副主任' },
          { name: '裴庆祺', position: '西安电子科技大学教授<br />陕西省区块链与安全计算重点实验室执行主任' },
          { name: '何德彪', position: '武汉大学教授' },
          { name: '郑子彬', position: '中山大学软件工程学院副院长、教授' },
          { name: '姜宇', position: '清华大学副教授' }
        ]
      }
    },
    {
      id: 2,
      type: 'pm',
      logo: basic.pmLogo,
      logoBlack: basic.pmLogoBlack,
      logoGrey: basic.pmLogoGrey,
      fontActiveBgColor: '#E7F2FF',
      fontActiveColor: '#376EFD',
      title: '产品经理赛道',
      mobileTitle: '产品经理',
      titleBgColor: 'linear-gradient(225deg, rgba(187,225,255,0) 0%, #DDEDFF 100%)',
      mobileTitleBgColor: 'linear-gradient(360deg, rgba(187,225,255,0) 0%, #DCECFF 100%)',
      mainJudge: {
        img: 'https://static001.geekbang.org/resource/image/07/9d/07e713d412b1f82318986a23e705639d.png',
        mobileImg: 'https://static001.geekbang.org/resource/image/56/cc/56561e4d45220a3546b1d1236b133bcc.png',
        name: '方震宇',
        conTitle: '评委主席',
        position: '微众银行行长助理'
      },
      Judgers: {
        title: '赛道评审',
        mobileTitle: '赛道评审',
        bgBg: 'https://static001.geekbang.org/resource/image/c0/e7/c0b5cc7467c6bc83eec15fb4183c7fe7.png',
        data: [
          { name: '祁涵', position: ' 深大微众金融科技学院院长助理' },
          { name: '方震宇', position: '微众银行行长助理' },
          { name: '厉卓', position: '微众银行个人直通银行部总经理' },
          { name: '王蒙', position: '微众银行数字产品部副总经理' },
          { name: '金虎光', position: '微众银行个人直通银行部室经理' },
          { name: '张凯', position: '广东财经大学副校长' },
          { name: '姜富伟', position: '中央财经大学金融学院系主任' }
        ]
      }
    }
  ],

  partners: [
    {
      title: '战略指导单位',
      list: [
        '深圳市地方金融监督管理局',
        '深圳市福田区人民政府',
        '深圳市南山区人民政府'
      ]
    },
    {
      title: '主办方',
      list: [
        '深大微众金融科技学院',
        '微众银行',
        '深圳香蜜湖国际金融科技研究院'
      ]
    },
    {
      title: '技术指导方',
      list: [
        'FISCO BCOS 开源社区',
        'FATE 开源社区',
        '中国电子技术标准化研究院',
        '深圳市金融区块链发展促进会'
      ]
    }
  ]
}
